import { FC } from 'react'
import MediaCard from './common/MediaCard'

type SetYourOwnMarginsCardType = {}

const SetYourOwnMarginsCard: FC<SetYourOwnMarginsCardType> = ({ }) => {
  return (
    <MediaCard
      image={{
        alt: 'Robot arm pointing right',
        desktop: {
          dimensions: {
            height: 484,
            width: 661,
          },
          src: '/images/new/robot-arm-pointing-right.png',
        },
        mobile: {
          dimensions: {
            height: 412,
            width: 536,
          },
          src: '/images/new/robot-arm-pointing-down.png',
        },
      }}
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'media-top-content-bottom',
      }}
      imageFitPreset='cover-right'
      imageContainerWidth='50%'
    >
      <div className='d-flex flex-1 flex-column gap-lg-4 p-5 pb-lg-10 pe-lg-10 pt-lg-26'>
        <h2 className='fw-semibold lh-1 fs-fluid-36-80'>
          Set your own <span className='color-pink2'>margins</span>.
        </h2>
        <span className='mt-8 mt-lg-0 fw-semibold fs-fluid-18-26'>
          With our simple single plan pricing structure, you have the freedom to
          set your own margins, allowing you to determine the ideal price point for
          your clients and market.
        </span>
        <div className='text-right mt-10 mt-lg-13'>
          <a
            className='btn btn-primary w-100 w-lg-auto btn-lg'
            href='#konnect-form'
          >
            Book a Demo
          </a>
        </div>
      </div>
    </MediaCard>
  )
}

export default SetYourOwnMarginsCard
